import React, { useState } from "react";
import "./project5.css";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";

function Project5() {
  const [main, setMain] = useState(false);
  const gotoMainPage = () => {
    setMain(true);
  };

  return (
    <>
      {!main ? (
        <div className="body">
          <div className="headerP1">
            <h2 id="Title">Real-Time Chat Application</h2>
            <div id="P1Github">
              <a
                href="https://github.com/AkhilTheBoss/Chat-Application"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button variant="secondary">Github</Button>
              </a>
            </div>
            <div id="mainPage">
              <Button variant="primary" onClick={gotoMainPage}>
                Main Page
              </Button>
            </div>
          </div>
          <br />
          <h4 className="Heading">Introduction</h4>
          <p className="Content">
            Created a web application where multiple users can group chat in
            chosen groups.
          </p>
          <h4 className="Heading">Explanation</h4>
          <p className="Content">
            Developed a chat in application that combines React for the
            frontend, Node for the backend, and SQL for the database. The
            application uses essential libraries like Socket.io for real-time
            communication, express for routing, and CORS for handling
            cross-origin requests.
            <div>
              In this application, users are required to input their names and
              choose a specific chat room they wish to join. Users within the
              same chat room share a common group chat. When a user sends a
              message, it travels from their browser to the server and is then
              stored in a database for future reference. Additionally, when a
              user enters a room, the server retrieves all previous messages
              associated with that particular group from the database and sends
              them to the user's browser for display, ensuring a seemless chat
              experience.
            </div>
          </p>
          <h4 className="Heading">Terms</h4>
          <p className="Content">
            <ul>
              <li>
                <strong>express: </strong>It is a tool to create web servers,
                handle incoming requests etc. It simplifies tasks like routing.
                What is routing? Express helps you define routes within this
                server. These routes determine how incoming HTTP requests (GET,
                POST etc) are handled based on their endpoints.
              </li>
              <li>
                <strong>socket.io: </strong>It is a library that enables
                real-time, bidirectional communication between clients and a
                server. It's particularly useful for building applications that
                require instant, interactive updates and notifications.
                Socket.io makes it easy to establish and maintain real-time
                connections between clients and servers. Real-time communication
                is a continuous flow of data between the client and server,
                where updates are pushed to the client as they happen, without
                the need for the client to repeatedly request the data.
              </li>
              <li>
                <strong>cors: </strong>(Cross-Origin Resource Sharing) this is a
                library that allows web pages to make a request to a different
                domain. It is typically used when you want to access resources
                hosted on other servers. In our application, the frontend is
                making HTTP requests to the backend. To enable cross-origin
                requests from the React application to the Node.js server (this
                is because both React and Node have different domains), you
                should configure CORS on the Node.js server.
              </li>
              <li>
                <strong>axios: </strong>It is a library that allows you to send
                HTTP requests to web servers.
              </li>
            </ul>
          </p>
        </div>
      ) : (
        <App />
      )}
    </>
  );
}

export default Project5;
